import { layoutVariationMap } from "../common/layyoutVariationMap";
import { fgFieldSchema } from "../common/serviceUtil";
import { getCreationForm } from "./createpageTemplate";
import { getDynamicDataTable, getDynamicDataTableTrial } from "./dynamicDataTableTemplate";
import { attachmentEditMode } from "./fgAttachmentConfiguration-editmode";
import { attachmentViewtMode } from "./fgAttachmentConfiguration-viewmode";
import { getModalDialogue } from "./modalDialogueTemplate";
import { wrapComponentsInLayout } from "./rowLayout";

// /getCreateForm(formFields: any, variation: string, layoutType: string): any
export function getCreateForm(
  fieldComps: any,
  isModalDialogue: boolean,
  viewVariationKey: any,
  title: any,
  linkFields:any ,
  modalDialogueProps:any,

): any {
  const variationConfig = viewVariationKey;

  // const fieldComps = generateFormFieldComponents(formFields, mode, "RENDER");

  
  let layout = []
  if(isModalDialogue){
    const layoutdComps = wrapComponentsInLayout(fieldComps, layoutVariationMap["card-simple"]);
    const layoutForRenderer = Array.isArray(layoutdComps)
    ? layoutdComps
    : [layoutdComps];
   layout =  getCreationForm(layoutForRenderer, title);
   const fieldList: string[] = fieldComps.map(obj => obj.key);
    layout =   getModalDialogue(layoutForRenderer,fieldList, title , modalDialogueProps.modalId)
  }else{
    const layoutdComps = wrapComponentsInLayout(fieldComps, variationConfig);
    const layoutForRenderer = Array.isArray(layoutdComps)
    ? layoutdComps
    : [layoutdComps];
   layout =  getCreationForm(layoutForRenderer, title);
  }
  

  //console.log(layout);
  return layout;
}

export function getPreviewForm(
  formFields: any,
  viewVariationKey: any,
  title: any,
  mode: any,
  linkFields:any
): any {
  const variationConfig = layoutVariationMap[viewVariationKey];

  const fieldComps = generateFormFieldComponents(formFields, mode, "PREVIEW" , linkFields);

  const layoutdComps = wrapComponentsInLayout(fieldComps, variationConfig);

  const layoutForRenderer = Array.isArray(layoutdComps)
    ? layoutdComps
    : [layoutdComps];
  const layout = getCreationForm(layoutForRenderer, title);

  //console.log(layout);
  return layout;
}

export function getViewForm(
  formFields: any,
  viewVariationKey: any,
  title: any,
  linkFields:any
  
): any {
  const variationConfig = layoutVariationMap[viewVariationKey];

  const fieldComps = generateFormFieldComponents(formFields, "VIEW", "PREVIEW",linkFields);
  const layoutdComps = wrapComponentsInLayout(fieldComps, variationConfig);

  const layoutForRenderer = Array.isArray(layoutdComps)
    ? layoutdComps
    : [layoutdComps];
  const layout = getCreationForm(layoutForRenderer, title);

  //console.log(layout);
  return layout;
}
export function generateFormFieldComponents(
  formFields: any[],
  mode: "EDIT" | "VIEW",
  purpose: "RENDER" | "PREVIEW",
  linkFields:any,
  editableSystemFields?:boolean 
): any[] {
  // const fieldSchema = fgFieldSchema;
  const fieldSchema = JSON.parse(JSON.stringify(fgFieldSchema));
  fieldSchema.tag = "";
  const components: any[] = [];

  formFields.forEach((field) => {
    let componentTemplate: any = null;
    const fieldType = field.type?.toLowerCase();
    const fieldSchemaType = field.fieldType?.toUpperCase();

    if (field.fieldType === "FILE") {
      const attachmentComponent =
        mode === "EDIT"
          ? { ...attachmentEditMode }
          : { ...attachmentViewtMode };

      // Set the key dynamically if needed from the field
      attachmentComponent.key = field.fieldCode;
      attachmentComponent.label = field.label || "Attachment";
      attachmentComponent.name = field.name || "Attachment";

      components.push(attachmentComponent);
      return; // Skip further default processing
    }

    // VIEW MODE OVERRIDE
    if (mode === "VIEW" || (field.tag==='System' && !editableSystemFields)) {
      componentTemplate = {
        type: "fgvalue",
        input: "value",
        name: "Field Value",
        label: field.displayName || field.name,
        icon: "fa fa-terminal",
        condition: {},
        isCoreConfig: true,
        category: "INPUT",
        key: field.name,
        prefix: null,
        uuid: crypto.randomUUID(),
        tag: field.tag,
      };

      // Add specific enhancements for data type if needed (e.g., for amount, date)
      if (field.type === "decimal") {
        componentTemplate.isAmount = true;
        componentTemplate.prefixType = "symbol";
      }

      if (field.type === "date" || field.type === "datetime") {
        componentTemplate.dateFormat = "dd-MMM-yyyy";
      }

      components.push(componentTemplate);
      return;
    }

    // Default EDIT Mode Logic
    if (
      purpose === "RENDER" &&
      (fieldSchemaType === "ENTITY" || fieldSchemaType === "DYNAMICLOOKUP")
    ) {
      componentTemplate = {
        type: "fgselect",
        label: field.displayName || field.name,
        name: "Select Drop down",
        icon: "fa fa-th-list",
        values: [],
        validation: {},
        condition: {},
        isCoreConfig: true,
        category: "INPUT",
        selectConfig: {
          chipPattern: "",
          dataSourceType: "model",
          selectedModel: field.fieldTypeKey || "",
          modelLabelField: field.translationDisplayField || "",
          modelValueField: field.translationValueField || "",
        },
        uuid: crypto.randomUUID(),
        key: field.name,
        styles: {},
        searchEnabled: true,
        showCancelButton: true,
        tag: field.tag,
      };
    } else {
      switch (fieldType) {
        case "text":
          componentTemplate = fieldSchema.find(
            (f) => f.type === "fginput" && f.input === "text"
          );
          break;
        case "decimal":
        case "long":
        case "integer":
          componentTemplate = fieldSchema.find(
            (f) => f.type === "fginput" && f.input === "number"
          );
          break;
        case "clob":
        case "textarea":
          componentTemplate = fieldSchema.find((f) => f.type === "fgtextarea");
          break;
        case "boolean":
          componentTemplate = fieldSchema.find((f) => f.type === "fgcheckbox");
          break;
        case "date":
        case "datetime":
          componentTemplate = fieldSchema.find(
            (f) => f.type === "fginput" && f.input === "date"
          );
          break;
        case "link":
          componentTemplate = getDynamicDataTableTrial(field.name , linkFields[field.name ] )
          break;
        default:
          console.warn(`Unsupported field type: ${fieldType}`);
      }

      if (componentTemplate) {
        componentTemplate = {
          ...componentTemplate,
          label: field.displayName,
          key: field.name,
          name: componentTemplate.name || field.displayName,
          validation: {
            required: field.isMandatory || false,
            minLength: field.minLength,
            maxLength: field.maxLength,
          },
          condition: {},
          category: "INPUT",
          prefix: null,
          tag: field.tag,
        };
      }
    }

    if (componentTemplate) {
      components.push(componentTemplate);
    }
  });

  return components;
}
